import axios from '@/libs/api.request'

/**
 * 重置密码
 */
export const resetPass = (user_id) => {
    const data ={
        "user_id": user_id
    }
    return axios.request({
        url: '/api/admin/user/resetPassword',
        data,
        method: 'post'
    })
}

/**
 * 查询用户与角色的数据
 */
 export const getUserRoleData = (userId) => {
    const data = {
        'userId': userId
    }
    return axios.request({
        url: '/api/admin/user/role',
        data,
        method: 'post'
    })
}

/**
 * 批量添加用户角色
 */
export const saveRoleBatch = (role_ids, user_ids) => {
    const data = {
        'role_ids': role_ids,
        'user_ids': user_ids
    }
    return axios.request({
        url: '/api/admin/user/saveRoleBatch',
        data,
        method: 'post'
    })
}

/**
 * 检查加密狗
 */
export const checkShield = () => {
    return axios.request({
        url: '/api/admin/user/checkShield',
        method: 'post'
    })
}

/**
 * 生成Hash
 */
export const getHash = () => {
    return axios.request({
        url: '/api/admin/user/getHash',
        method: 'post'
    })
}


/**
 * 分配项目（多项目用户）
 */
 export const allocationProject = (user_id, org_ids) => {
    const data = {
        'user_id': user_id,
        'org_ids': org_ids
    }
    return axios.request({
        url: '/api/admin/userproject/save',
        data,
        method: 'post'
    })
}

/**
 * 获取审核人员列表 （技术人员+超级用户）
 */
 export const getShUserList = () => {
    return axios.request({
        url: '/api/admin/user/getShUserList',
        method: 'post'
    })
}

/**
 * 获取审核人员列表（超级用户）
 */
 export const getShUserList1 = () => {
    return axios.request({
        url: '/api/admin/user/getShUserList1',
        method: 'post'
    })
}
